import React from "react";
import classNames from "classnames";
import { ErrorIcon, NoticeTriangleIcon, InfoIcon, SuccessIcon, NoticeIcon } from "@netapp/bxp-style/react-icons/Notification";
import { Span} from "./../../";
import styles from "./InlineNotification.module.scss";

const iconTypeMapper = {
    error: { icon: ErrorIcon },
    warning: { icon: NoticeTriangleIcon },
    success: { icon: SuccessIcon },
    info: { icon: InfoIcon },
    urgent: { icon: NoticeTriangleIcon },
    critical: {icon: NoticeIcon}
};

export default ({children, type, className, style, prefix, ...rest}) => {
    const Icon = iconTypeMapper[type].icon;
    return (
        <div className={classNames(styles["base"], styles[type], className)} style={style} {...rest}>
            <Icon className={styles["icon"]}/>
            <Span>{prefix && <Span bold>{prefix}: </Span>}{children}</Span>
        </div>
    );
};
